import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    tasks: {
        id: "test.tasks",
    },
    meta: {
        id: "test.meta",
    },
    comment: {
        id: "test.comment",
    },
    refresh: {
        id: "shareModal.refresh",
    },
    refreshNotPlayable: {
        id: "plan.refreshNotPlayable",
    },
    labelNotPlayable: {
        id: "plan.labelNotPlayable",
    },
    refreshNotLabeled: {
        id: "plan.refreshNotLabeled",
    },
    metaFirst: {
        id: "plan.metaFirst",
    },
    share: {
        id: "planCard.share",
    },
    publish: {
        id: "planCard.publish",
    },
    label: {
        id: "plan.label",
    },
    verifyEmail: {
        id: "listing.verifyEmail",
    },
    newHomework: {
        id: "plan.newHomework",
    },
    score: {
        id: "plan.score",
    },
    scores: {
        id: "plan.scores",
    },
    logInToGadgets: {
        id: "plan.logInToGadgets",
    },
    clonePublic: {
        id: "planCard.duplicate",
    },
    covidUse: {
        id: "plan.covidUse",
    },
    modifiedRefresh: {
        id: "plan.modifiedRefresh",
    },
    experience: {
        id: "plan.experience",
    },
    invalidExperince: {
        id: "plan.invalidExperince.tooltip",
    }
});

export default messages;
